import { render, staticRenderFns } from "./FounderPage.vue?vue&type=template&id=6ebf4dde&scoped=true&"
import script from "./FounderPage.vue?vue&type=script&lang=js&"
export * from "./FounderPage.vue?vue&type=script&lang=js&"
import style0 from "./FounderPage.vue?vue&type=style&index=0&id=6ebf4dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebf4dde",
  null
  
)

export default component.exports